import operations from './operations'
import router from './router'
import pblManagement from './pblManagement'
import user from './user'
import changePassword from './changePassword'
import ttl from './ttl'

const DAEMON = '@@saga-injector/daemon'
const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount'
// @generator sagas:import
export const allSagas = [
  // @generator sagas:export
  { key: 'ttl', value: ttl },
  { key: 'changePassword', value: changePassword },
  { key: 'user', value: user },
  { key: 'router', value: router },
  { key: 'operations', value: operations },
  { key: 'pblManagement', value: pblManagement }
]

export function injectSaga(store, { key, asyncSaga }) {
  // Reset injected Sagas
  const newSaga = {
    saga: asyncSaga,
    mode: asyncSaga.mode || DAEMON
  }

  const { saga, mode } = newSaga

  let hasSaga = Reflect.has(store.injectedSagas, key)

  if (process.env.NODE_ENV !== 'production') {
    const oldSaga = store.injectedSagas[key]
    // enable hot reloading of daemon and once-till-unmount sagas
    if (hasSaga && oldSaga.saga !== saga) {
      oldSaga.task.cancel()
      hasSaga = false
    }
  }

  if (!hasSaga || (hasSaga && mode !== DAEMON && mode !== ONCE_TILL_UNMOUNT)) {
    store.injectedSagas[key] = {
      ...newSaga,
      task: store.runSaga(saga)
    }
  }
  ejectSaga(store, key)
}

export function ejectSaga(store, key) {
  if (Reflect.has(store.injectedSagas, key)) {
    const descriptor = store.injectedSagas[key]
    if (descriptor.mode && descriptor.mode !== DAEMON) {
      descriptor.task.cancel()
      // Clean up in production; in development we need `descriptor.saga` for hot reloading
      if (process.env.NODE_ENV === 'production') {
        // Need some value to be able to detect `ONCE_TILL_UNMOUNT` sagas in `injectSaga`
        store.injectedSagas[key] = 'done' // eslint-disable-line no-param-reassign
      }
    }
  }
}
